// extracted by mini-css-extract-plugin
module.exports = {"methodLabel":"MethodLabel_methodLabel__2NTnU"};